import { Injectable } from '@angular/core';
import {CanActivate, Router} from "@angular/router";
import {LoginService} from "@app/login/login.service";

@Injectable({
    providedIn: "root"
})
export class AdminRouteGuardService implements CanActivate{

    constructor(private router: Router, private loginService: LoginService) { }

    canActivate(): boolean {
        let canAccess: boolean;
        if(this.loginService.activeUser.superAdmin){
            canAccess = true;
        }
        else if(this.loginService.activeUser.admin){
            canAccess = true;
        }
        else {
            canAccess = false;
            this.router.navigate(['/news']);
        }
        return canAccess;
    }
}
